import { forwardRef } from 'react';
import { t } from 'i18next';
// configs
import { EX8083 } from 'config/flags';
// components
import { Popover, PopoverProps } from 'rsuite';
import EXButton from '@commons/EXComponentsLibrary/ExButton/Button';
// styles
import styles from './PopoverMultiples.module.css';

interface PopoverMultiplesProps extends Omit<PopoverProps, 'title' | 'children'> {
    quantity: number;
    action: () => void;
    updatedQuantityRule: any | null | undefined;
}

const PopoverMultiples = forwardRef<HTMLDivElement, PopoverMultiplesProps>(
    ({ quantity, action, updatedQuantityRule, ...props }, ref) => {
        const title = EX8083
            ? updatedQuantityRule?.id === 3
                ? t('comparative.titlePopoverMultiple')
                : updatedQuantityRule?.id === 2
                ? t('comparative.titlePopoverMaximun')
                : t('comparative.titlePopoverMinimun')
            : t('comparative.titlePopoverMultiple');
        const subTitle = EX8083
            ? updatedQuantityRule?.id === 3
                ? t('comparative.subTitlePopoverMultiple', { value: quantity })
                : updatedQuantityRule?.id === 2
                ? t('comparative.subTitlePopoverMaximun', { value: quantity })
                : t('comparative.subTitlePopoverMinimun', { value: quantity })
            : t('comparative.subTitlePopoverMultiple', { value: quantity });
        return (
            <div className={styles['whisper-popover']}>
                <Popover
                    ref={ref}
                    title={
                        <p className={styles['wrapper-title']}>
                            <img draggable={false} alt="warning message icon" src="/assets/images/warning_square.svg" />
                            <span className={styles['title']}>{title}</span>
                        </p>
                    }
                    {...props}
                >
                    <div className={styles['wrapper-content']}>
                        <p className={styles['text']}>{subTitle}</p>
                        <div className={styles['button']}>
                            <EXButton onClick={action}>Entendido</EXButton>
                        </div>
                    </div>
                </Popover>
            </div>
        );
    },
);

export default PopoverMultiples;
